// Auth helpers — cliente e staff partilham o mesmo login
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getToken() {
  return localStorage.getItem("token");
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function setAuth(token, user) {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
}

export function clearAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("admin_token");
}

export function authHeaders() {
  return { Authorization: `Bearer ${getToken()}` };
}

export function isStaff() {
  const u = getUser();
  return u && ["superadmin", "admin", "funcionario"].includes(u.role);
}

export { API };
